var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRuleShoppingCartHeatmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20.75C5.26 20.75 4.25 19.74 4.25 18.5C4.25 17.6 4.78 16.82 5.55 16.46L3.84 3.75H2C1.59 3.75 1.25 3.41 1.25 3C1.25 2.59 1.59 2.25 2 2.25H4.5C4.88 2.25 5.19 2.53 5.24 2.9L5.55 5.25H19.99C20.2 5.25 20.41 5.34 20.55 5.5C20.69 5.66 20.76 5.88 20.73 6.09L20.23 10.09C20.18 10.5 19.8 10.79 19.39 10.74C18.98 10.69 18.69 10.31 18.74 9.9L19.13 6.74H5.85L6.52 12.15C6.6 12.77 7.13 13.24 7.76 13.24H10C10.41 13.24 10.75 13.58 10.75 13.99C10.75 14.4 10.41 14.74 10 14.74H7.76C7.43 14.74 7.1 14.68 6.8 14.57L7.02 16.24H9.99C10.4 16.24 10.74 16.57 10.74 16.99C10.74 17.41 10.4 17.74 9.99 17.74H8.61C8.69 17.97 8.74 18.23 8.74 18.49C8.74 19.73 7.73 20.74 6.49 20.74L6.5 20.75ZM6.5 17.75C6.09 17.75 5.75 18.09 5.75 18.5C5.75 18.91 6.09 19.25 6.5 19.25C6.91 19.25 7.25 18.91 7.25 18.5C7.25 18.09 6.91 17.75 6.5 17.75Z",
    fill: "#747E87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15H15.75C15.3358 15 15 15.3358 15 15.75V16C15 16.4142 15.3358 16.75 15.75 16.75H16C16.4142 16.75 16.75 16.4142 16.75 16V15.75C16.75 15.3358 16.4142 15 16 15Z",
    fill: "#747E87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.75H15.75C15.3358 17.75 15 18.0858 15 18.5V19.25C15 19.6642 15.3358 20 15.75 20H16.5C16.9142 20 17.25 19.6642 17.25 19.25V18.5C17.25 18.0858 16.9142 17.75 16.5 17.75Z",
    fill: "#747E87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 18.25H19C18.5858 18.25 18.25 18.5858 18.25 19V19.25C18.25 19.6642 18.5858 20 19 20H19.25C19.6642 20 20 19.6642 20 19.25V19C20 18.5858 19.6642 18.25 19.25 18.25Z",
    fill: "#747E87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.75H15C13.48 22.75 12.25 21.52 12.25 20V15C12.25 13.48 13.48 12.25 15 12.25H20C21.52 12.25 22.75 13.48 22.75 15V20C22.75 21.52 21.52 22.75 20 22.75ZM15 13.75C14.31 13.75 13.75 14.31 13.75 15V20C13.75 20.69 14.31 21.25 15 21.25H20C20.69 21.25 21.25 20.69 21.25 20V15C21.25 14.31 20.69 13.75 20 13.75H15Z",
    fill: "#747E87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRuleShoppingCartHeatmap);
export default __webpack_public_path__ + "static/media/icon-rule-shopping-cart-heatmap.b3fddbc65f25d4904beb0481af4049ea.svg";
export { ForwardRef as ReactComponent };